// Централизованный логгер.
// В production debug/info глушатся, warn/error остаются и могут быть
// перенаправлены во внешние сервисы (Sentry, LogRocket и пр.).

const isProd = process.env.NODE_ENV === 'production'

type LogArgs = unknown[]

const noop = (..._args: LogArgs): void => {}

export const logger = {
	debug: isProd ? noop : (...args: LogArgs) => console.debug('[debug]', ...args),
	info: isProd ? noop : (...args: LogArgs) => console.info('[info]', ...args),
	warn: (...args: LogArgs) => console.warn('[warn]', ...args),
	error: (...args: LogArgs) => {
		console.error('[error]', ...args)
		// Точка интеграции с Sentry / другим reporting-сервисом:
		// if (isProd) window.Sentry?.captureException(args[0])
	},
}

export default logger
